export const validationMessages = {
  required: (field: string) => `${field} is required.`,
  minLength: (field: string, length: number) =>
    `${field} must be at least ${length} characters.`,
  maxLength: (field: string, length: number) =>
    `${field} must be no more than ${length} characters.`,
  invalid: (field: string) => `Please enter a valid ${field}.`,
  pastDate: (field: string) => `${field} must be a past date.`,
  exactLength: (field: string, length: number) =>
    `${field} must be exactly ${length} characters.`,
};
